export default __webpack_public_path__ + "static/media/734.3c296fb0.png";